import styled from 'styled-components'
import { lightGray } from '../../styles/variables'
import { fieldLabel } from '../../styles/common'

const TagsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  align-items: center;
  position: relative;

  ${fieldLabel}

  &.twoRows > label {
    margin-right: 25px;
  }
  &.disabled {
    opacity: 0.7;
  }
`

const Tags = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 180px;

  &.oneLine {
    max-width: none;
    & > div {
      flex: 0 0;
      margin-right: 5px;
      & > div {
        padding: 8px 10px;
        min-width: 45px;
      }
    }
  }
`

const TagContainer = styled.div`
  margin-right: 16px;
  position: relative;
  margin-bottom: 8px;
  flex: 1 0 41%;
`

const Tag = styled.div`
  box-sizing: border-box;
  text-align: center;
  padding: 10px 20px;
  outline: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }

  background: none;
  border: 2px solid ${lightGray};
  color: ${lightGray};

  &.selected {
    background: ${lightGray};
    border: 2px solid ${lightGray};
    color: white;
  }

  &.error {
    border: 2px solid red;
  }
`

const ErrorLabel = styled.label`
  position: absolute;
  bottom: -6px;
  color: red !important;
  margin-top: 4px;
  margin-right: 25px;
  left: 42px;
`

export default {
  TagsContainer,
  TagContainer,
  Tags,
  Tag,
  ErrorLabel,
}
